import {
  ADD_USER_TO_CONVERSATION_LIST,
  ON_CHANGE_CONVERSATION,
  ON_DISPLAY_DETAIL_CONTACT,
  ON_DISPLAY_MODAL_USERS,
  ON_LOAD_MESSAGE_LIST,
  ON_LOAD_MESSAGE_LIST_FAILED,
  ON_LOAD_MESSAGE_LIST_SUCCESS,
  ON_LOAD_USER_CONVERSATION_LIST,
  ON_LOAD_USER_CONVERSATION_LIST_FAILED,
  ON_LOAD_USER_CONVERSATION_LIST_SUCCESS,
  ON_RESET_USER_CONVERSATION,
} from './constants';

const initialState = {
  showModalAddUser: undefined,
  showDetailSection: undefined,
  activeConversation: undefined,
  conversationList: [],
  messageList: [],
  error: null,
  loading: false,
};

const chatReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case ON_LOAD_MESSAGE_LIST:
      return { ...state, loading: true };
    case ON_LOAD_MESSAGE_LIST_SUCCESS:
      return { ...state, messageList: action.payload.messages, loading: false };
    case ON_LOAD_MESSAGE_LIST_FAILED:
      return { ...state, error: action.payload.error, loading: false };

    case ON_DISPLAY_MODAL_USERS:
      return { ...state, showModalAddUser: action.payload.status };
    case ON_DISPLAY_DETAIL_CONTACT:
      return { ...state, showDetailSection: action.payload.status };

    case ADD_USER_TO_CONVERSATION_LIST: {
      const { user } = action.payload;
      const search = state.conversationList.some((i) => i.id === user.id);
      const newList = !search ? [...state.conversationList, user] : state.conversationList;
      return {
        ...state,
        conversationList: newList,
        activeConversation: user,
      };
    }
    case ON_RESET_USER_CONVERSATION: {
      return {
        ...state,
        activeConversation: null,
        conversationList: state.conversationList.map((i) => ({ ...i, activeChat: false })),
      };
    }
    case ON_CHANGE_CONVERSATION: {
      const { user, id } = action.payload;
      return {
        ...state,
        activeConversation: user,
        conversationList: state.conversationList.map((i) =>
          i.cognito_id === id || i.id === id
            ? { ...i, activeChat: true }
            : { ...i, activeChat: false },
        ),
      };
    }

    case ON_LOAD_USER_CONVERSATION_LIST:
      return { ...state, loading: true };
    case ON_LOAD_USER_CONVERSATION_LIST_SUCCESS:
      return { ...state, conversationList: action.payload.userList, loading: false };
    case ON_LOAD_USER_CONVERSATION_LIST_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    default:
      return state;
  }
};

export default chatReducer;
